import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { NotificationEnum } from "../types/settings.definition";

export const notificationsSchema = (t: TFunction) =>
  z.object({
    notifications: z
      .array(z.nativeEnum(NotificationEnum), {
        message: t("common.validation.required"),
      })
      .min(0),
  });

export const useNotificationsSchema = () => {
  const { t } = useTranslation();
  return notificationsSchema(t);
};

export type NotificationsSchema = z.infer<
  ReturnType<typeof useNotificationsSchema>
>;
